import * as actionTypes from '../../types/header';
import * as userActions from '../../types/user';

export const initialState = {
  isFetching: false,
  isLoading: true,
  error: false,
  navbarConfig: {},
  accessRoutes: [],
  access: {},
  routes: {},
};

const header = (state = initialState, action) => {
  switch (action.type) {
  case actionTypes.GET_NAVBAR: {
    return {
      ...state,
      isFetching: true,
    };
  }
  case actionTypes.GET_NAVBAR_SUCCESS: {
    return {
      ...state,
      isFetching: true,
      navbarConfig: action.data,
      accessRoutes: action.menu,
      access: action.data.access,
      routes: action.data.routes,
    };
  }

  case actionTypes.GET_NAVBAR_COUNTERS_SUCCESS: {
    return {
      ...state,
      accessRoutes: state?.accessRoutes?.map((route) => {
        const finded = action?.data?.find((c) => c.code === route.code);
        if (finded) {
          return {
            ...route,
            count: finded.count,
          };
        }
        return route;
      }),
    };
  }

  case userActions.USER_AUTH_LOGOUT:
  case userActions.USER_AUTH_LOGOUT_CREDENTIALS: {
    return {
      ...state,
      isFetching: true,
      navbarConfig: {},
      accessRoutes: [],
      access: {},
      routes: {},
    };
  }

  case actionTypes.GET_NAVBAR_ERROR: {
    return {
      ...state,
      isFetching: false,
      error: action?.payload?.error || 'Navbar error',
    };
  }

  default: {
    break;
  }
  }

  return state;
};

export default header;
